import type { PayloadAction } from '@reduxjs/toolkit';

import type { RouterState } from './_state.type';

/** Router Reducer. */
export const routerReducer = {
  /**
   * Set Reload Document when Routing.
   *
   * @param {RouterState} state State.
   * @param {PayloadAction<boolean>} action Action.
   */
  router_setReloadDocument: (state: RouterState, { payload }: PayloadAction<boolean>) => {
    state.router.reloadDocument = payload;
  },

  /**
   * Set Back link.
   *
   * @param {RouterState} state State.
   * @param {PayloadAction<string>} action Action.
   */
  router_setBackLink: (state: RouterState, { payload }: PayloadAction<string>) => {
    state.router.backLink = payload;
  },
};
